import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router } from '@angular/router';
import { Api } from '../../providers/api';

@Component({
  selector: 'my-app-sidenav',
  styles: [],
  template: require('./sidenav.component.html')
})

export class AppSidenavComponent implements OnInit {
  AppConfig;
  userName: string = "Anonymous";
  logoImgUrl: string = "assets/images/placeholder.jpg";
  squareLogoImage = "";


  constructor(private router: Router, private api: Api) {
    if (localStorage.getItem(APPCONFIG.prefix + 'isLoggedIn') && localStorage.getItem(APPCONFIG.prefix + 'isLoggedIn') == 'true') {
      this.userName = this.getUserName();
      this.logoImgUrl = this.getImageUrl();
    }

  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.squareLogoImage = this.getSquareLogoImage();
    // this.squareLogoImage = "https://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
  }

  imageNotFoundServer(event) {
    // event.target.src = "https://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
  }


  toggleCollapsedNav() {
    this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
  }

  logout() {
    // this.api.activateLoader();
    this.api.get("user/logout").subscribe((res) => {
      localStorage.removeItem('currentUser')
      localStorage.removeItem(APPCONFIG.prefix + 'isLoggedIn');
      this.router.navigate(['/extra/login'], { queryParams: { logoutStatus: 'success' } });


      // this.api.hideLoader();
    }, err => {
      console.log(err);
      //if (err.status == 401) {
      localStorage.removeItem('currentUser')
      localStorage.removeItem(APPCONFIG.prefix + 'isLoggedIn');
      this.router.navigate(['/extra/login'], { queryParams: { logoutStatus: 'success' } });
      // this.api.hideLoader();
      // }
    });
  }

  getUserName() {

    var fName = JSON.parse(localStorage.getItem('currentUser')).firstName;
    var lName = JSON.parse(localStorage.getItem('currentUser')).lastName;

    if (typeof fName === 'undefined') {
      fName = " ";
    }
    if (typeof lName === 'undefined') {
      lName = " ";
    }

    return fName + " " + lName;
  }

  getImageUrl() {
    return JSON.parse(localStorage.getItem('currentUser')).adpCustomerInfo.logoImgUrl || "assets/images/placeholder.jpg";
  }

  getSquareLogoImage() {
    return this.AppConfig.imagesBaseUrl + "/" + this.api.getADPCustomerUUID() + "/" + this.AppConfig.brandingFolder + "/logoSquare.png?v=" + Math.round((new Date()).getTime() / 1000);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/sidenav/sidenav.component.ts